import ConfirmDialog from "../../commons/dialog/confirmDialog";
import { formBehaviourEnum } from "../../commons/enum/formEnums";
import { StyledForm } from "../../styled/form";
import AmContainer from "./am/amContainer";
import FormContainerCards from "./formContainerCards";
import FormDialogWrapper from "./formDialogWrapper";
import FpaContainer from "./fpa/fpaContainer";
import FptFormContainer from "./fpt/fptFormContainer";
import IamiContainer from "./iami/iamiContainer";
import IdrContainer from "./idr/idrContainer";
import IetContainer from "./iet/ietContainer";

/**
 *
 * @param {string?} open: Nombre del form que esta abierto actualmente. Null si no hay ninguno abierto
 * @param {function} handleDialogClose: Función a utilizar cuando se intente cerrar el dialog sin enviar el form.
 * @param {object} selectedDocument: En caso de que el form existe previamente, aca se envian datos revelantes como nroFormulario, idResError.
 * @param {function} handleClose: Función de cerrar cuando el form se envia.
 * @param {string} formTitle: En caso que es un nuevo form, se pasa el titulo del form ejemplo (Formulario de Pedido de Transporte)
 * @param {enum} behaviour: Un valor del enum formBehaviourEnum. En bas ea este valor cambian algunos comportamientos del componente. Ejemplo: si es MODIFY_ACCIDENT_DOCUMENT se muestra la lista de otros documentos del siniestro
 * @param {array} documentList: Lista de documentos (seleccionables) a mostrar mientras se edita el form
 * @param {function} changeSelectedDocument: Funcion que pasandole un documento cambia si es otro documento
 * @param {bool} loaded: Es true si el form tiene todo lo necesario para ser editado
 * @param {function} setLoaded: Funcion para modificar loaded
 * @param {bool} loadingForm: Esto marca si el modelo/form esta siendo cargaddo o no.
 * @param {bool} isView: Para saber si es un documento nuevo o la vista de uno ya creado anteriormente
 * @param {bool} isRepeatForm: Carga un documento existente pero lo guarda como uno nuevo
 * @param {bool?} disabled: Si este valor es distinto de null ignora los permisos del usuario y siempre permite o no la edicion del form.
 * @param {number} idSiniestro
 * @param {number} idArt
 * @param {function} postFormCallback: Funcion que se ejecuta despues de que el form se guarde correctamente
 * @param {bool} openCancelDialog: Si es true, muestra el dialogo respecto a cancelar el llenado del form.
 * @param {function} handleCancelFormCancelDialog: Cierra la ventana de dialogo sin cancelar el form
 * @param {function} handleConfirmFormCancelDialog: Cierra la pantalla de form cancelandolo
 * @param {string} art: Nombre de la art
 * @param {bool} errorLoadingForm: Esto es true solo si el ultimo form/model en cargarse dio error
 * @returns Dialog con el form correspondiente
 */
const Form = ({
  openForm,
  handleDialogClose,
  selectedDocument,
  handleClose,
  formTitle,
  behaviour,
  documentList,
  changeSelectedDocument,
  loaded,
  setLoaded,
  loadingForm,
  isView,
  isRepeatForm,
  disabled,
  idSiniestro,
  idArt,
  postFormCallback,
  openCancelDialog,
  handleCancelFormCancelDialog,
  handleConfirmFormCancelDialog,
  artName,
  commonProperties,
  errorLoadingForm,
  isDialog,
}) => {
  return (
    <>
      <FormDialogWrapper
        openForm={openForm}
        handleDialogClose={handleDialogClose}
        selectedDocument={selectedDocument}
        handleClose={handleClose}
        formTitle={formTitle}
        loadingForm={loadingForm}
        idSiniestro={idSiniestro}
        artName={artName}
        commonProperties={commonProperties}
        errorLoadingForm={errorLoadingForm}
        isDialog={isDialog}
      >
        <>
          {documentList &&
            (behaviour == formBehaviourEnum.MODIFY_ACCIDENT_DOCUMENT ||
              behaviour == formBehaviourEnum.ATTENTION_IN_OTHER_PROVIDER) && (
              <StyledForm.DocumentsContainer>
                <FormContainerCards
                  data={documentList}
                  selectedDocument={selectedDocument}
                  changeSelectedDocument={changeSelectedDocument}
                  disableChange={!loaded}
                  commonProperties={commonProperties}
                />
              </StyledForm.DocumentsContainer>
            )}
          <StyledForm.DocumentContainer>
            {!loadingForm &&
              {
                iami: (
                  <IamiContainer
                    handleClose={handleClose}
                    isView={isView}
                    setLoaded={setLoaded}
                    selectedDocument={selectedDocument}
                    disabled={disabled}
                    idSiniestro={idSiniestro}
                    idArt={idArt}
                    postFormCallback={postFormCallback}
                    handleOpenCancelDialog={handleDialogClose}
                  />
                ),
                iet: (
                  <IetContainer
                    handleClose={handleClose}
                    isView={isView}
                    setLoaded={setLoaded}
                    selectedDocument={selectedDocument}
                    disabled={disabled}
                    idSiniestro={idSiniestro}
                    idArt={idArt}
                    postFormCallback={postFormCallback}
                    handleOpenCancelDialog={handleDialogClose}
                  />
                ),
                fpa: (
                  <FpaContainer
                    handleClose={handleClose}
                    isView={isView}
                    setLoaded={setLoaded}
                    selectedDocument={selectedDocument}
                    disabled={disabled}
                    idSiniestro={idSiniestro}
                    idArt={idArt}
                    postFormCallback={postFormCallback}
                    handleOpenCancelDialog={handleDialogClose}
                    trabajador={commonProperties.trabajador}
                  />
                ),
                fpt: (
                  <FptFormContainer
                    handleClose={handleClose}
                    isRepeatForm={isRepeatForm}
                    isView={isView}
                    setLoaded={setLoaded}
                    selectedDocument={selectedDocument}
                    disabled={disabled}
                    idSiniestro={idSiniestro}
                    idArt={idArt}
                    postFormCallback={postFormCallback}
                    handleOpenCancelDialog={handleDialogClose}
                  />
                ),
                am: (
                  <AmContainer
                    handleClose={handleClose}
                    isView={isView}
                    setLoaded={setLoaded}
                    selectedDocument={selectedDocument}
                    disabled={disabled}
                    idSiniestro={idSiniestro}
                    idArt={idArt}
                    postFormCallback={postFormCallback}
                    handleOpenCancelDialog={handleDialogClose}
                  />
                ),
                idr: (
                  <IdrContainer
                    handleClose={handleClose}
                    isView={isView}
                    setLoaded={setLoaded}
                    selectedDocument={selectedDocument}
                    disabled={disabled}
                    idSiniestro={idSiniestro}
                    idArt={idArt}
                    postFormCallback={postFormCallback}
                    handleOpenCancelDialog={handleDialogClose}
                  />
                ),
              }[openForm]}
          </StyledForm.DocumentContainer>
        </>
      </FormDialogWrapper >
      <ConfirmDialog
        open={openCancelDialog}
        handleClose={handleCancelFormCancelDialog}
        handleConfirm={handleConfirmFormCancelDialog}
        title="CERRAR VENTANA"
        text="¿Está seguro que desea cancelar esta operación? En caso de aceptar, se perderá la información ingresada"
      />
    </>
  );
};

export default Form;
